export enum dateTimeFormat {
  LOCAL_DATE_FORMAT = 'll',
  MONTH_TIME = 'MMM DD, hh:mm A',
  LOCAL_DATE_FORMAT_TIME = 'll | hh:mm A',
  LOCAL_DATE_FORMAT_NO_TIME_ZONE = 'll | hh:mm a',
  LOCAL_FORMAT_TIME = 'HH:mm a',
  HOUR_FORMAT = 'HH:mm:ss',
  MINUTE_FORMAT = 'mm:ss',
  DATE_TIME_FORMAT = 'lll',
  DAY_FORMAT = 'D MMM',
  MONTH_FORMAT = 'MMM D',
  YEAR_FORMAT = 'D MMM YYYY',
  DASH_YEAR_FORMAT = 'MM/DD/YYYY',
  COMMA_YEAR_FORMAT = 'MMMM D, YYYY',
  DOT_YEAR_FORMAT = 'MM.DD.YYYY',
  SERVER_DATE_FORMAT = 'YYYY-MM-DD',
  SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm',
  SERVER_DATE_TIME_WITH_S_FORMAT = 'YYYY-MM-DDTHH:mm:ss',
  MIN_COMMA_YEAR_FORMAT = 'MMM D, YYYY',
  MIN_COMMA_YEAR_FORMAT2 = 'MMM, YYYY',
  HOUR_MIN_FORMAT = 'HH:mm',
  LOCAL_12_HOUR_FORMAT_TIME = 'LT',
  MONTH_YEAR_FORMAT = 'MMM YYYY',
}

export enum unitOfTime {
  weeks = 'weeks',
  seconds = 'seconds',
  years = 'years',
  day = 'day',
  days = 'days',
  year = 'year',
  month = 'month',
  minutes = 'minutes',
}

export const displayTimeFormats = [
  dateTimeFormat.DATE_TIME_FORMAT,
  dateTimeFormat.LOCAL_DATE_FORMAT_TIME,
  dateTimeFormat.LOCAL_12_HOUR_FORMAT_TIME,
];

export const serverTimeFormats = [
  dateTimeFormat.SERVER_DATE_TIME_FORMAT,
  dateTimeFormat.SERVER_DATE_TIME_WITH_S_FORMAT,
];

export const validTimeFormats = [...displayTimeFormats, ...serverTimeFormats];
